<script lang="ts">
	import type { InputInlineProps, InputSelectProps } from '../types';
	import InputInline from '../InputInline.svelte';
	import { t } from 'svelte-i18n';
	import type { InputSelectOption } from '../types';
	import type { Country } from 'world-countries';
	import { onMount } from 'svelte';
	import InputSelect from './InputSelect.svelte';
	import { attrValue } from '$lib/utils/html';
	import { snackbar } from '$lib/stores';

	export let props: InputInlineProps;
	export let phoneCodesProps: InputSelectProps;
	export let withCode: boolean;
	export let isCodeNotRequired: boolean;

	const getCountriesPhoneCodes = async () => {
		try {
			const res = await fetch('/countries/');

			if (res.ok) {
				const countries = await res.json();

				let phoneCodesSelectOptions: InputSelectOption[] = countries
					.sort((e1: Country) => (e1.translations.fra.common.toLowerCase() === 'france' ? -1 : 1))
					.map((c: Country) => {
						return {
							label: `${c.flag} ${c.idd.root}${c.idd.suffixes} (${c.translations.fra.common})`,
							value: c.cca3
						};
					});
				phoneCodesProps = Object.assign(phoneCodesProps, {
					label: $t('subscription.countryCode'),
					options: phoneCodesSelectOptions,
					withSearchBar: true,
					required: !isCodeNotRequired
				});
			} else {
				snackbar.danger($t('subscription.countryCodeError'));
			}
		} catch (e) {
			snackbar.danger($t('subscription.countryCodeError'));
		}
	};

	onMount(() => {
		if (withCode) {
			getCountriesPhoneCodes();
		}
	});
</script>

<div class="md:flex md:space-x-4">
	{#if withCode && phoneCodesProps}
		<div class="md:w-1/3">
			<InputSelect bind:props={phoneCodesProps} />
		</div>
	{/if}
	<div class={attrValue([withCode && phoneCodesProps ? 'md:w-2/3' : 'w-full'])}>
		<InputInline type="tel" pattern="[0-9]+" bind:props />
	</div>
</div>
